import React from 'react';
import { Twitter, Facebook, Instagram, Youtube } from 'lucide-react';

const Footer = () => {
  const socialLinks = [
    { icon: Twitter, href: 'https://twitter.com/swaborgio', label: 'Twitter' },
    { icon: Facebook, href: 'https://www.facebook.com/swissborg', label: 'Facebook' },
    { icon: Instagram, href: 'https://www.instagram.com/swissborg/', label: 'Instagram' },
    { icon: Youtube, href: 'https://www.youtube.com/c/SwissBorg', label: 'Youtube' }
  ];

  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="flex flex-col items-center gap-8">
          {/* Logo and description */}
          <div className="text-center">
            <div className="mb-4 flex justify-center">
              <img 
                src="https://upload.wikimedia.org/wikipedia/commons/b/ba/Swissborg-logo.png" 
                alt="SwissBorg" 
                className="h-12 w-auto"
              />
            </div>
            <p className="text-gray-500 text-sm">
              Wealth Management for the Digital Age™
            </p>
          </div>

          {/* Social Links */}
          <div className="flex gap-4">
            {socialLinks.map((social, index) => (
              <a
                key={index}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-100 hover:bg-[#01C38D] rounded-full flex items-center justify-center text-gray-500 hover:text-white transition-all"
                aria-label={social.label}
              >
                <social.icon className="w-5 h-5" />
              </a>
            ))}
          </div>

          {/* Copyright */}
          <div className="pt-8 border-t border-gray-200 w-full">
            <p className="text-gray-500 text-sm text-center">
              © 2025 SwissBorg. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
